module.exports = __webpack_public_path__ + "2e7a2eb91ad77cdc55feb92df5434626.png";